import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { ModelType, RequestModelTypeResponse, UpdateTypeModelRequestDTO } from "@/types";

async function updateTypeModel(
  request: UpdateTypeModelRequestDTO
): Promise<ModelType> {
  const { id, ...updateData } = request;
  const response = await httpRequest.put<RequestModelTypeResponse>(
    `/models-types/${id}`,
    updateData
  );
  return response.data.data;
}

export function useUpdateTypeModelMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateTypeModel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["models-types"] });
      queryClient.invalidateQueries({ queryKey: ["models"] });
    },
  });
}
